<template>
  <q-item v-bind="$attrs">
    <q-item-section>
      <q-item-label>
        <p class="q-mb-sm"><strong>Failed to generate album:</strong></p>
        <p class="q-mb-none">{{ data.fileName }}</p>
      </q-item-label>
      <q-item-label caption>
        <slot></slot>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface AlbumFileNotGenerated {
  reportId: number,
  fileName: string,
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => AlbumFileNotGenerated,
      required: true,
    },
  },
});
</script>
